import React from 'react';
import { ExternalLinkIcon, StarIcon } from 'lucide-react';
import { useGoogleReviews, type GoogleReviewsSnapshot } from '../hooks/useGoogleReviews';
import { Section, SectionHeading } from './shared';
const GOOGLE_REVIEWS_URL = 'https://www.google.com/search?q=Separovic+Injury+Lawyers+Perth+reviews';
const FALLBACK_REVIEWS: GoogleReviewsSnapshot = {
  rating: 4.7,
  totalReviews: 300,
  reviews: [{
    name: 'Candice Van-Ross',
    rating: 5,
    text: 'He was extremely professional, supportive, and always took the time to explain things clearly to me. He guided me through the entire process, kept me updated, and made what could have been a stressful situation so much easier.'
  }, {
    name: 'Darren Kuhn',
    rating: 5,
    text: 'I got a great result with my claim, it exceeded my expectations by quite a lot of money. Very happy with the result — thank you to the Separovic team.'
  }, {
    name: 'Rob Mandanici',
    rating: 5,
    text: 'Great firm to deal with, empathetic team who were firm with their advice, understanding of the issues and helpful along the way.'
  }]
};
function ReviewStars({
  rating = 5
}: {
  rating?: number;
}) {
  const filledStars = Math.round(rating);
  return <span className="flex" aria-label={`${rating} out of 5 stars`} data-id="element-574" data-mp="79v6x9xrjgh7">
      {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className={`h-4 w-4 ${star < filledStars ? 'fill-gold text-gold' : 'text-ink/20'}`} strokeWidth={star < filledStars ? 0 : 1.5} data-id="element-575" data-mp="c8okt3gyp9hw" />)}
    </span>;
}
export function Testimonials() {
  const {
    data,
    isLive
  } = useGoogleReviews(FALLBACK_REVIEWS);
  return <Section id="reviews" className="bg-canvas" data-id="element-576" data-mp="v4o5dt7m1arg">
      <SectionHeading eyebrow="Google reviews" title="Trusted by Injured Western Australians" intro="Independent client feedback provides a clearer picture of what it is like to work with our team." align="center" data-id="element-577" data-mp="v3d1lte6030c" />

      <a href={GOOGLE_REVIEWS_URL} className="mx-auto mt-8 flex max-w-3xl flex-col items-center justify-between gap-4 rounded-card border border-ink/5 bg-paper p-5 text-center shadow-card transition-[transform,border-color] duration-200 ease-out hover:-translate-y-0.5 hover:border-gold/35 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal sm:flex-row sm:text-left" aria-label="View Separovic Injury Lawyers Google reviews" data-id="element-578" data-mp="1xgplhfziqya6">
        <div className="flex items-center gap-4" data-id="element-579" data-mp="19s6autszy9ex">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-warm-tint font-serif text-[24px] font-semibold text-forest" data-id="element-580" data-mp="19qbqphpjulbw">
            G
          </span>
          <span data-id="element-581" data-mp="10tkw79qnbejf">
            <span className="block text-[13px] font-semibold uppercase tracking-[0.12em] text-gold" data-id="element-582" data-mp="10px1i79gsm34">
              {isLive ? 'Live Google rating' : 'Google rating'}
            </span>
            <span className="mt-1 flex flex-wrap items-center justify-center gap-2 sm:justify-start" data-id="element-583" data-mp="quc46mfcc9zp">
              <strong className="text-[24px] leading-none text-forest" data-id="element-584" data-mp="32j0970jyrhea">
                {data.rating.toFixed(1)}
              </strong>
              <ReviewStars rating={data.rating} data-id="element-585" data-mp="3cfd39zjf7x9k" />
              <span className="text-small text-slate" data-id="element-586" data-mp="3cfv5rdwof7px">
                {isLive ? `${data.totalReviews} reviews` : `Around ${data.totalReviews} reviews`}
              </span>
            </span>
          </span>
        </div>
        <span className="inline-flex items-center gap-2 text-[15px] font-semibold text-forest" data-id="element-587" data-mp="2jol7h369pamr">
          View on Google
          <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-588" data-mp="2srcl99mm8ihk" />
        </span>
      </a>

      <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-589" data-mp="2xht2z5xgyq9q">
        {data.reviews.map(review => <figure key={`${review.name}-${review.text.slice(0, 24)}`} className="flex h-full flex-col rounded-card border border-ink/5 bg-paper p-6 shadow-card" data-id="element-590" data-mp="210g9ydg7elwe">
            <ReviewStars rating={review.rating} data-id="element-591" data-mp="1lwn6gx413toy" />
            <blockquote className="mt-4 flex-1 text-[16px] leading-[1.65] text-ink" data-id="element-592" data-mp="1lxewlseuwz7u">
              “{review.text}”
            </blockquote>
            <figcaption className="mt-5 border-t border-ink/8 pt-4" data-id="element-593" data-mp="1vmg8b6edcug0">
              <p className="font-semibold text-forest" data-id="element-594" data-mp="1voszma60oh5q">{review.name}</p>
              <p className="mt-1 text-small text-slate" data-id="element-595" data-mp="1qv802dorzf4f">Google review</p>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
}